import type { InventoryTree } from '@scaleaq/sitecontrol-lib';

import type { GlobalInventorySite } from './inventory.types.ts';

export const buildScopedRoute = (
  route: string,
  inventoryId: string | undefined,
  parameters?: Record<string, string>
) => {
  const search = new URLSearchParams(parameters);
  if (inventoryId) search.set('inventoryId', inventoryId);
  const query = search.toString();
  return query ? `${route}?${query}` : route;
};

/** Sites from a by-type list. Rows without `SiteBase` cannot be addressed. */
export const selectGlobalInventorySites = (
  nodes: readonly Pick<InventoryTree, 'id' | 'name' | 'fields'>[] | undefined
): GlobalInventorySite[] | undefined => {
  if (!nodes) return undefined;
  return nodes.flatMap(node => {
    const siteBase = node.fields?.SiteBase;
    if (!siteBase) return [];
    return [{ id: node.id, name: node.name, fields: { SiteBase: siteBase } }];
  });
};
